'use strict';

angular.module('impactx.comments').controller('CommentOnSaveCtrl', CommentOnSaveCtrl);

CommentOnSaveCtrl.$inject = ['$scope', '$mdDialog', 'themeFactory', 'dataGen', 'warning', 'saveLabel', 'abortLabel',
    'commentLabel', 'commentDTO'];

function CommentOnSaveCtrl($scope, $mdDialog, themeFactory, dataGen, warning, saveLabel, abortLabel, commentLabel, commentDTO)
{
    $scope.warning = warning;
    $scope.saveLabel = saveLabel;
    $scope.abortLabel = abortLabel;
    $scope.commentLabel = commentLabel;
    $scope.commentDTO = commentDTO;
    $scope.newComment = '';
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        var dataObj = {
            commentToken: $scope.commentDTO.commentToken,
            newComment: $scope.newComment
        };
        var newCommentScope = {};
        dataGen.postAsForm(newCommentScope, dataObj, "/comment/add").then(function()
        {
            $mdDialog.hide();
        });
    };
}